/**
 * 'action' attributes for ajax requests
 */
export const PING_ACTION = 'ping';
export const LOGIN_ACTION = 'requestLogin';
export const LOGOUT_ACTION = 'requestLogout';
export const INSERT_GRAB_ACTION = 'insertGrabRequest';
// export const = 'appendGrabRequest';
export const GET_GRABBED_IMAGE_ACTION = 'getGrabbedImage';
export const GET_GRABBED_PAGE_ACTION = 'getGrabbedPage';
// export const = 'requestPatientProfile';
// export const = 'procedureSearch';
export const ADD_EXTRACTION_ACTION = 'addExtraction';
// export const = 'requestApplicationReset';
export const REQUEST_ININITIAL_MESSAGE = 'requestInitialMessage';
export const REQUEST_WATCHLIST_ACTION = 'requestWatchList';
export const SAVE_WATCHLIST_ACTION = 'saveWatchList';

// export const = 'requestAutoAddReport';
export const SAVE_STATE_ACTION = 'saveState';
export const ENTER_PATIENT_CHART_ACTION = 'enterPatientChart';
export const SHARE_ACQUIRE_ACTION = 'acquireByExternalId';
export const SHARE_SUMMARY_ACTION = 'summaryByExternalId';
export const EXIT_PATIENT_CHART_ACTION = 'exitPatientChart';
export const INVITE_PATIENT_ACTION ='invitePatient';
export const UNINVITE_PATIENT_ACTION ='uninvitePatient';
export const ASSIGN_PROV_ACTION = 'provAssignmentById'

// export const = 'getState';
export const REQUEST_CDA_ACTION = 'requestCda';
export const DOWNLOAD_CDA_ACTION = 'downloadCda';
export const REQUEST_PDF_ACTION = 'requestPdf';
export const SAVE_CDA_ACTION = 'requestCommitAutoAddCda';
// export const = 'requestCommitAutoAddReport';
export const SCAN_CDA_ACTION = 'requestAutoAddCda';
export const DELETE_CDA_ACTION = 'deleteCda';
// Ajax action: re-parse CDA XML for structured medication import fields at import time.
export const CDA_MEDICATION_IMPORT_ACTION = 'cdaMedicationImport';
// export const = 'insertPage';
// export const = 'appendPage';
// export const = 'removePage';
// export const = 'cancelExtraction';
// export const = 'showExtraction';
// export const = 'showOriginal';
export const SEARCH_CATEGORY_ACTION = 'searchCategory';
export const SEARCH_PROCEDURE_ACTION = 'searchProcedure';
export const SEARCH_NPI_ACTION = 'searchNpi';
export const RESOLVE_NPI_ACTION = 'resolveNpi';
export const GET_PREVIEW_ACTION = 'getPreview';
export const SAVE_EXTRACTION_ACTION = 'saveExtraction';
export const REQUEST_REPORT_ACTION = 'requestReport';
// export const = 'requestNpis';
export const SAVE_PAGE_ACTION = 'savePages';
// export const = 'getExtractPagePos';
// export const = 'getOriginalPagePos';
// export const = 'ocrSelection';
// export const = 'requestRelatedUsers';
// export const = 'requestFindUsers';
// export const = 'requestRelated';
// export const = 'requestSetPermission';
// export const = 'requestUpdateUserProfile';
export const USER_REGISTRATION_ACTION = 'requestAddUser';
export const IS_USER_EXIST_ACTION = 'isUserExist';
export const IS_EMAIL_EXIST_ACTION = 'isEmailExist'
export const IS_PERM_EXIST_ACTION ='isPermExist';
export const IS_NPI_EXIST_ACTION = 'isNpiExist'
export const FORGOT_PASSWORD_ACTION = 'forgotPassword';
export const RESET_PASSWORD_ACTION = 'requestResetPassword';
export const UPDATE_PASSWORD_ACTION = 'requestUpdatePassword';
export const UPDATE_USERNAME_ACTION = 'requestUpdateUsername';
export const UPDATE_EMAIL_ACTION = 'requestUpdateEmail';
export const CHANGE_PASSWORD_ACTION = 'changePassword';
export const VERIFICATION_ACTION = 'verify';
export const REQUEST_NEW_TOKEN_ACTION = 'requestNewToken';
// export const = 'requestOnePatientRelationInformation';
// export const = 'setOnePatientRelationInformation';
// export const = 'requestPatientRelationInformation';
// export const = 'requestPatientRelationPermissionInformation';
// export const = 'setPatientRelationPermission';
// export const REQUEST_GRAB_ACTION = 'requestGrabMessage';
// file upload actions
export const CDA_UPLOAD_ACTION = "ccda";
export const PDF_UPLOAD_ACTION = "pdf";
export const UPDATE_PROFILE_ACTION = "updateProfile"
export const GET_CONTACTS_ACTION = "getContacts";
export const CREATE_CONTACT_ACTION = "createContact";
export const UPDATE_CONTACT_ACTION = "updateContact";
export const DELETE_CONTACT_ACTION = "deleteContact";
export const RENAME_CONTACT_ACTION = "renameContact";
export const UPDATE_PREFERENCES_ACTION = "updatePreferences";
export const GET_PREFERENCES_ACTION = "getPreferences";

export const GET_LICENSES_ACTION = 'query';
export const UPDATE_LICENSE_STATUS_ACTION = 'updateStatus';

export const CREATE_DEVICE = "createDevice";

export const GET_NOTES = "getNotes";
export const UPDATE_NOTES = "updateNotes"
export const DELETE_NOTES = "deleteNotes"
